import api from "./index";
import store from "@/store";
import { v4 as uuid } from "uuid";

export async function getAttendances(params) {
  return api.get(`/attendances`, { params: params });
}

export async function getAttendance(id) {
  return api.get(`/attendances/${id}`);
}

export async function generateMeet(id) {
  return api.post(`/attendances/${id}/meet`);
}

export async function getAttendancesTypes() {
  return api.get(`/attendances/types`);
}

export async function getAttendancesWaitingMe() {
  return api.get(`/attendances/waiting/me`);
}

export async function getAttendancesInProgressMe(params) {
  return api.get(`/attendances/in-progress/me`, { params: params });
}

export async function getAttendancesStatusAnalytics(params) {
  return api.get(`/attendances/status/analytics`, { params: params });
}

export async function getAttendancesReportConsolidated(params) {
  return api.get(`/attendances/report/consolidated`, { params: params });
}

export async function getConsolidedQueue(params) {
  return api.get(`/attendances/report/queue/consolidated`, { params: params });
}

export async function getAttendancesExport(params) {
  const id = uuid();
  const controller = new AbortController();

  const label = `Exportando atendimentos (${params?.format || "arquivo"})`;

  store.commit("download/ADD", { id, label, controller });

  let lastLoaded = 0;
  let lastTime = Date.now();

  try {
    const response = await api.get("/attendances/export", {
      params,
      responseType: "blob",
      signal: controller.signal,
      onDownloadProgress: (event) => {
        const now = Date.now();
        const deltaBytes = event.loaded - lastLoaded;
        const deltaTime = (now - lastTime) / 1000; // segundos

        const speed = deltaBytes / deltaTime; // bytes/s
        const speedMB = (speed / (1024 * 1024)).toFixed(2);
        const loadedMB = (event.loaded / (1024 * 1024)).toFixed(2);

        // aqui você salva na store usando uma string ao invés de %
        store.commit("download/PROGRESS", {
          id,
          progressText: `${loadedMB}/(${speedMB} MB/s)`,
          loadedBytes: event.loaded,
        });

        lastLoaded = event.loaded;
        lastTime = now;
      },
    });

    store.commit("download/FINISH", id);
    return response;
  } catch (error) {
    if (error.name === "CanceledError") {
      store.commit("download/CANCELED", id);
      return;
    }

    store.commit("download/ERROR", id);
    throw error;
  }
}
